module.exports = __webpack_public_path__ + "static/media/premium.bda1e0c2.png";